const mapModes = [
  {
    key: "dark",
    text: "Dark Map",
    value: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
  },
  {
    key: "light",
    text: "Light Map",
    value:
      "https://api.mapbox.com/styles/v1/mscob/cki02bw572oga1bquvhj0d3g8/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoibXNjb2IiLCJhIjoiY2tmMDU1OGdxMGxtajJxbzBkd3Zoa28xOSJ9.Tw_9fGMoBJ3AMym8fgZ7Mg"
  },
  {
    key: "satellite",
    text: "Satellite",
    value: "https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
  }
];

const getMapMode = key => {
  const mode = mapModes.find(item => item.key === key) || null;

  if (mode) {
    return mode.value;
  } else {
    return null;
  }
};

export { mapModes, getMapMode };
